var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.title),expression:"title"}],staticClass:"app-details-toggle",attrs:{"aria-label":_vm.title},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ArrowRight',{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }